import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { DebentureLiabilityCategory } from 'src/types/operations/debentures';

import {
  formatLiabilityCategoryCurrency,
  isNegativeLiabilityValue,
} from '../utils';

interface OperationDebenturesLiabilityCategoryTableProps {
  categories: DebentureLiabilityCategory[];
}

export default function OperationDebenturesLiabilityCategoryTable({
  categories,
}: OperationDebenturesLiabilityCategoryTableProps) {
  return (
    <TableContainer component={Paper} square sx={{ mb: 4 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell
              sx={(theme) => ({
                fontSize: '12px',
                fontWeight: theme.typography.fontWeightBold,
              })}>
              Categoria
            </TableCell>
            <TableCell
              align="right"
              sx={(theme) => ({
                fontSize: '12px',
                fontWeight: theme.typography.fontWeightBold,
              })}>
              Valor (R$)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {categories.map(({ label, value }) => (
            <TableRow key={label}>
              <TableCell sx={{ fontSize: '0.8em' }}>{label}</TableCell>
              <TableCell
                align="right"
                sx={{
                  fontSize: '0.8em',
                  color: isNegativeLiabilityValue(value)
                    ? 'error.main'
                    : 'text.primary',
                }}>
                {formatLiabilityCategoryCurrency(value)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
